import React from "react"

import {FieldViewGroupProps} from "../../../../../render/group/@type"
import PriorityIcon from "../../../../../../gd-components/priority/priority-icon/priority-icon"

// const debug = "FieldTaskPriority_ViewGroup"
const debug = false

export default function FieldTaskPriority_ViewGroup(props: FieldViewGroupProps) {

    const value = props.field.getViewValue(props.model)

    debug && console.log(debug, 'render', value)

    const classes = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <PriorityIcon className="size-15 m-t-2" priority={value}/>
                </div>
            }
            <div className="max-w-100-percent txt-truncate view-group-label">{props.field.groupLabel(value, props.groupBy)}</div>
        </div>
    )
}



